import React from 'react';
import LoginHelper from "/components/ui/LoginHelper"
import { getCsrfToken, getSession } from 'next-auth/client'
import isMobileDetect from '/lib/services/helpers/isMobileDetect';
 
import { useNotifyModal } from "/lib/hooks/useNotifyModal";
import dynamic from "next/dynamic";
const NotifyModal = dynamic(() => import('/components/NotifyModal'))

function Login(props) {
   
  const { showNotifyModal, handleModalClose } = useNotifyModal();

  return (
    <>
      {showNotifyModal ? <NotifyModal
        handleModalClose={handleModalClose}
        className='notifyContent'
        isOpen={showNotifyModal}
      /> : null}
      <LoginHelper props={props} />
    </>
  );
}

export default Login;

export async function getServerSideProps(ctx) {
  const { req, res } = ctx
  const csrfToken = await getCsrfToken(ctx)||null
  const { cookies } = req

  if (typeof window !== "undefined" && res.writeHead) {
    if (cookies.token) {
      res.writeHead(302, { Location: "/customer/account" });
      res.end();
    }
  }
  const session = await getSession(ctx)

  return { props: { isSsrMobile: isMobileDetect(req), cookies: cookies, csrfToken, session } }
}